import React, { useState, useEffect, useContext, useMemo } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import axios from "axios";
import styled from "styled-components";
import _ from "lodash";
import Slider from "@mui/material/Slider";
import ActionPlansContext from "context/ActionPlansContext";
import ActionContext from "context/ActionContext";
import UserService from "services/UserService";
import { getSite } from "services/ConfigServices";
import {
  CustomSelect,
  TextInput,
  FloatInput,
  IntInput,
} from "components/Input/Index.js";

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const UploadButton = styled.div`
  margin-left: 15px;
  &:hover {
    cursor: pointer;
  }
`;

const marks = [
  {
    value: 0,
    label: "0%",
  },
  {
    value: 100,
    label: "100%",
  },
];

const PrettoSlider = withStyles({
  root: {
    color: "#91C73C",
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
  markLabel: {
    top: "26px",
    color: "rgba(0, 0, 0, 0.54)",
    position: "absolute",
    fontSize: "13px",
    transform: "translateX(-50%)",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1.43,
    whiteSpace: "nowrap",
    letterSpacing: "0.01071em",
  },
  marked: {
    marginTop: "-3.5px",
    marginBottom: "4px",
  },
})(Slider);

const customStyles = {
  header: {
    style: {
      minHeight: "80px",
    },
  },
};

function valuetext(value) {
  return `${value}%`;
}

const reducer = (previousValue, currentValue) => previousValue + currentValue;

export default function useActionTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanadmin = permis.includes("actionplan_admin");
  const [totalRows, setTotalRows] = useState(0);

  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;

  const [initialized, setInitialized] = useState(false);
  const [structureData, setStructureData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [sliderValue, setSliderValue] = useState(action.parameters?.impact?.globalconsumptionpart * 100);

  useEffect(() => {
    let data = [];
    axios
      .get(getSite(action.parameters.general.groups[0], "equipments.equipmentlist"), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        data = res?.data?.detail?.equipments?.equipmentlist || [];
        setInitialized(true);
        setStructureData([
          ...data,
        ]);
        let equipments = action.parameters?.impact?.equipments || [];
        let equipmentsIds = equipments.map((equipment) => {
          return equipment.uuid;
        });
        let alldata = [
          ...data.filter((obj) => !equipmentsIds.includes(obj.uuid)),
          ...equipments,
        ];
        const filteredItems = alldata.filter(
          (item) =>
            (item.energysource && action.parameters?.impact?.targetedenergy.find((x) => x.id == item.energysource))
        );
        setFilteredData(filteredItems);
      });
  }, []);


  useEffect(() => {
    if (initialized) {
      calculateEco(sliderValue);
    }
  }, [action.parameters?.impact?.equipments?.length,
  action.parameters?.impact?.targetedenergy?.length,
  action.parameters?.impact?.targetedenergychange]);

  const handleSliderChange = (event, value) => {
    setSliderValue(value);
    calculateEco(value);
  };

  const calculateEco = (value) => {
    let globalconsumptionpart = Number((value * 0.01).toFixed(2));
    let targetedenergy = action.parameters?.impact?.targetedenergy;
    let equipments = action.parameters?.impact?.equipments;
    let newTargetedenergy = [];
    let newEquipments = [];

    //at this point selected equiments should only came from equipments
    let newStructureData = structureData.map((equipment) => {
      let newequipment = {
        ...equipment,
        isSelected: false,
      };
      return newequipment;
    });

    targetedenergy.forEach((e) =>
      newTargetedenergy.push({
        ...e,
        earnings: earningsResult(e, value),
      })
    );

    equipments.forEach((e) =>
      newEquipments.push({
        ...e,
        consumptionpartNew:
          e.consumptionpart - e.consumptionpart * globalconsumptionpart,
      })
    );

    let equipmentsIds = newEquipments.map((equipment) => {
      return equipment.uuid;
    });
    let alldata = [
      ...newStructureData.filter((obj) => !equipmentsIds.includes(obj.uuid)),
      ...newEquipments,
    ];
    const filteredItems = alldata.filter(
      (item) =>
        (item.energysource && action.parameters?.impact?.targetedenergy.find((x) => x.id == item.energysource))
    );

    setFilteredData(filteredItems);
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          globalconsumptionpart,
          targetedenergy: newTargetedenergy,
          equipments: newEquipments,
        },
      },
    }));
  }

  function earningsResult(targetedenergy, value) {
    let equipments = action.parameters?.impact?.equipments;
    let globalconsumptionpart = Number((value * 0.01).toFixed(2));
    let selectedEnergy = targetedenergy.id;
    let selectedMetersConsumptionpart = equipments
      .filter((e) => e.energysource == selectedEnergy)
      .map((e) => e.consumptionpart * globalconsumptionpart);

    let totalconsumptionpart = selectedMetersConsumptionpart.reduce(reducer, 0);

    let energyValue = targetedenergy.value;

    // let calcul = energyValue - totalconsumptionpart * energyValue;
    let calcul = totalconsumptionpart * energyValue;
    return calcul;
  }

  const headerComponentMemo = useMemo(() => {
    return (
      <>
        <TableName>Liste des equipements</TableName>
      </>
    );
  }, []);

  const contextActions = React.useMemo(() => {
    return (
      <div
        style={{
          marginRight: "1.5rem",
          marginTop: "0.8rem",
        }}
      >
        <div
          style={{
            fontSize: "13px",
            opacity: "0.8",
            fontFamily: "Source Sans Pro,sans-serif",
          }}
        >
          Pourcentage de réduction de la part de conso.
        </div>
        <PrettoSlider
          defaultValue={(
            action.parameters?.impact?.globalconsumptionpart * 100
          ).toFixed(2)}
          getAriaValueText={valuetext}
          aria-labelledby="discrete-slider-small-steps"
          step={1}
          min={0}
          max={100}
          valueLabelDisplay="auto"
          marks={marks}
          onChangeCommitted={handleSliderChange}
        />
      </div>
    );
  }, [structureData, action.parameters?.impact?.targetedenergy?.length,
    action.parameters?.impact?.equipments?.length,
    action.parameters?.impact?.targetedenergychange]);


  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);


  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredData,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      title: headerComponentMemo,
      //subHeaderComponent: <SubHeaderComponent />,
      //headerComponent: headerComponentMemo,
      // contextComponent: <ContextComponent />,
      contextActions: contextActions,
      customStyles: customStyles,
    },
  };
}
